import { useMutation } from '@tanstack/react-query';
import { useRouter } from 'next/navigation';

import { useAppDispatch, useAppSelector } from 'store';

import { openAuthModal, setRedirectUrl, setRequiredModal, setTicket } from 'modules/auth';
import { $api, errorHandler, globalConst, setConfirmationModal } from 'modules/global';
import { setVisibleXpModal } from 'modules/results';

export const useFinishTest = ({ onClose }: { onClose?: () => void }) => {
  const { replace } = useRouter();
  const isAuth = useAppSelector(({ user }) => user.phone);
  const dispatch = useAppDispatch();

  const { mutate: finishTest, ...args } = useMutation({
    mutationFn: async (ticketId: number) => {
      const { data } = await $api.get('/check-test', { params: { ticket_id: ticketId } });

      return data;
    },
    onSuccess: (_, ticketId) => {
      if (onClose) onClose();
      setConfirmationModal(false);

      if (!isAuth) {
        dispatch(openAuthModal());
        dispatch(setRequiredModal());
        dispatch(setRedirectUrl(`${globalConst.pageNames.RESULTS}/${ticketId}`));
        dispatch(setTicket(ticketId));
        return;
      }

      dispatch(setVisibleXpModal(true));

      replace(`${globalConst.pageNames.RESULTS}/${ticketId}`);
    },
    onError: errorHandler()
  });

  return { finishTest, ...args };
};
